var axios = require('axios')
const urlGetGiftCardTransactionStatusesLogs =  process.env.host + '/' + process.env.version + '/product-giftcard/cards/{CART_UUID}/transactions-statuses-logs'

axios.getGiftCardTransactionStatusesLogs = function (params, success, callBackError) {
  this.get(urlGetGiftCardTransactionStatusesLogs.replace('{CART_UUID}', params.cartUuid))
  .then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status === 400 && typeof callBackError !== 'undefined') {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

export default axios



// WEBPACK FOOTER //
// ./src/assets/api/Giftcard.js